import React, { useEffect, useState } from 'react'
import { getDomain } from '../utils'
import { SITES, isProd } from '../consts'
import { Menu, Dropdown } from 'antd'
import { Button } from '@guillotinaweb/react-gmi'

const URLS = {
  uvas: {
    'vinissimus.com': '/uva',
    'vinissimus.co.uk': '/grape',
    'vinissimus.fr': '/raisin',
    'hispavinus.de': '/traube',
    'italvinus.it': '/uva',
  },
}

export function Preview({ url, id }) {
  return (
    <>
      <b>View</b>
      <div className="preview-web">
        {SITES.map((site) => (
          <a
            href={`https://${getDomain(site)}${URLS[url][site]}/${id}/`}
            target="_blank"
          >
            {site}
          </a>
        ))}
      </div>
    </>
  )
}

const subdomain = isProd() ? 'www' : 'stage'

export function CustomPreview({
  label = 'Preview',
  preview = (v) => v,
  children,
  disabled,
  moreItems = null,
  openAllOption = true,
  domains,
  onBeforeClick = () => {},
  ...props
}) {
  const [prevs, setPrevs] = useState([])

  useEffect(() => {
    async function loadPreviews() {
      setPrevs([])
      setPrevs(
        domains ||
          (await Promise.all(
            [
              `https://${subdomain}.vinissimus.com/es/`,
              `https://${subdomain}.vinissimus.com/en/`,
              `https://${subdomain}.vinissimus.fr/fr/`,
              `https://${subdomain}.vinissimus.co.uk/en/`,
              `https://${subdomain}.hispavinus.de/de/`,
              `https://${subdomain}.italvinus.it/it/`,
            ].map(async (label) => {
              const res = preview(label)
              const url = res.then ? await res : res
              const [firstpart, query] = url.split('=')

              return {
                label,
                url: `${firstpart}=${encodeURIComponent(query)}`,
              }
            })
          ))
      )
    }
    loadPreviews()
  }, [preview])

  return (
    <Dropdown
      disabled={!prevs.length || disabled}
      overlay={
        <Menu>
          {prevs.map(({ label, url }) => (
            <Menu.Item key={label}>
              <div
                onClick={() => {
                  onBeforeClick(url)
                  window.open(url, '_blank')
                }}
              >
                {label}
              </div>
            </Menu.Item>
          ))}
          {moreItems}
          {openAllOption && (
            <Menu.Item key="open-all">
              <div
                onClick={() => {
                  prevs.forEach((p) => {
                    onBeforeClick(p.url)
                    window.open(p.url, '_blank')
                  })
                }}
              >
                Open all
              </div>
            </Menu.Item>
          )}
        </Menu>
      }
      placement="bottomCenter"
    >
      {children ? (
        children
      ) : (
        <Button disabled={!prevs.length || disabled} type="button" {...props}>
          {label}
        </Button>
      )}
    </Dropdown>
  )
}
